export default "__VITE_ASSET__e304d9c7__"